import moment from "moment"

export interface AppConfig {
  // API请求url
  baseAPIUrl: string
  // 信令服务器url
  signalingUrl: string
  // 网站url
  siteUrl: string
  // 重置密码url
  resetPassUrl: string
}

// 本地开发环境
const DEV_CONFIG: AppConfig = {
  baseAPIUrl: "https://console-test.ked.ksyun.com/api",
  signalingUrl: "https://c-test.ked.ksyun.com",
  siteUrl: "http://localhost:3000",
  resetPassUrl: "https://pass-dev.aipc.ksyun.com",
}

// 测试环境
const TEST_CONFIG: AppConfig = {
  baseAPIUrl: "https://console-test.ked.ksyun.com/api",
  signalingUrl: "https://c-test.ked.ksyun.com",
  siteUrl: "https://web-test.ked.ksyun.com:8443",
  resetPassUrl: "https://pass.aipc.ksyun.com",
}

// 新测试环境
const NEW_TEST_CONFIG: AppConfig = {
  baseAPIUrl: "https://dev-console.ked.ksyun.com/api",
  signalingUrl: "https://dev-signaling.ked.ksyun.com",
  siteUrl: "https://dev-web.aipc.ksyun.com",
  resetPassUrl: "https://pass-dev.aipc.ksyun.com",
}

// 预发布环境
const PRE_CONFIG: AppConfig = {
  // baseAPIUrl: "https://console-pre.ked.ksyun.com/api",
  baseAPIUrl: "https://a.ked.ksyun.com/api",
  signalingUrl: "https://c.ked.ksyun.com",
  siteUrl: "https://webpre.ked.ksyun.com",
  resetPassUrl: "https://pass.aipc.ksyun.com",
}

// 正式环境
const PROD_CONFIG: AppConfig = {
  baseAPIUrl: "https://a.ked.ksyun.com/api",
  signalingUrl: "https://c.ked.ksyun.com",
  siteUrl: "https://web.aipc.ksyun.com",
  resetPassUrl: "https://pass.aipc.ksyun.com",
}

// 新正式环境
const NEW_PROD_CONFIG: AppConfig = {
  // baseAPIUrl: "https://prod-console.ked.ksyun.com/api",
  // signalingUrl: "https://prod-signaling.ked.ksyun.com",
  // siteUrl: "https://web-desk-prod.ked.ksyun.com",
  // resetPassUrl: "https://pass-prod.ked.ksyun.com",

  baseAPIUrl: "https://a.ked.ksyun.com/api",
  signalingUrl: "https://c.ked.ksyun.com",
  siteUrl: "https://web.aipc.ksyun.com",
  resetPassUrl: "https://pass.aipc.ksyun.com",
}

export function getAppConfig(): AppConfig {
  const env = process.env.REACT_APP_ENV
  console.log("env=:", env)
  switch (env) {
    case "dev":
      // return DEV_CONFIG // 开发环境
      // return PROD_CONFIG // 正式环境
      // return TEST_CONFIG // 测试环境
      // return NEW_TEST_CONFIG // 新测试环境
      return NEW_PROD_CONFIG // 新正式环境
    // return PRE_CONFIG // 预发布环境

    case "test":
      return TEST_CONFIG
    case "newtest":
      return NEW_TEST_CONFIG

    case "prod":
      return PROD_CONFIG

    case "newprod":
      return NEW_PROD_CONFIG
    case "pre":
      return PRE_CONFIG
    default:
      console.error("Unknown env: ", env, "Use dev config instead.")
      return DEV_CONFIG
  }
}

export function isDevEnv(): boolean {
  return process.env.REACT_APP_ENV === "dev"
}
export function isProdEnv(): boolean {
  return process.env.REACT_APP_ENV === "newprod"
}
export function isPreEnv(): boolean {
  return process.env.REACT_APP_ENV === "pre"
}

export function getAppVersion(): string {
  return process.env.REACT_APP_VERSION ?? "unknow"
}

export function getCommitNum(): string {
  return process.env.REACT_APP_COMMIT_NUM ?? "unknow"
}

export function getBuildTime(): string | null {
  const buildTimestamp = process.env.REACT_APP_BUILD_TIME
  if (!buildTimestamp) {
    return null
  }
  const timestamp = Number(buildTimestamp)
  if (!Number.isFinite(timestamp)) {
    return null
  }
  return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm")
}
